module.exports = __webpack_public_path__ + "static/media/broken-heart.687692c4.svg";